<template>
  <v-card color="white" flat class="pa-1 position-relative py-3">
    <div class="d-flex flex-column px-3">
      <div class="d-flex justify-space-between">
        <div class="text-h5"><b>Historial de facturación</b></div>
        <Button 
           icon="mdi-close"
           color="grey"
           size="small" 
           @click="$emit('close')"
         >
         </Button>
      </div>
      <div class="text-h6"><b>Lote:</b> {{ lotData.LotName }} - ID: {{ lotData.ID_RealStateLot }}</div>
      <div 
        v-if="installmentData && typeof installmentData === 'object'"
        class="text-h6"
      >
        <b>Cuota:</b> 
        #{{ installmentData.InstallmentNumber }} 
        - {{ installmentData.PeriodName }} 
        - ID: {{ installmentData.ID_FinancingInstallment }} 
      </div>
    </div>
    <Block v-if="isLoading" />
    <DxDataGrid
      :dataSource="billing"
      :showBorders="true"
      :show-row-lines="false"
      ref="dataGrid"
      :scrolling="{ useNative: true }"
      :paging="{ enabled: false }"
      :column-auto-width="true"
      style="max-height: 600px"
    >
      <DxColumn cell-template="actions-template" />
      <template #actions-template="{ data }">
        <div class="row-actions d-flex justify-center align-center" >
          <!-- <Button 
            v-if="!isInstallmentPaid(data.data)"
            icon="mdi-eye" 
            size="small" 
            class="mr-1"
            @click="$emit('row-selected', data.data)"
          >
          </Button> -->
          <Button 
            v-if="data.data.IsProcessed"
            icon="mdi-receipt-text-outline" 
            size="small" 
            class="mr-1"
            @click="generateReceiptPdf(data.data)"
          >
          </Button>
        </div>
      </template>

      <DxColumn 
        v-if="!(installmentData && typeof installmentData === 'object')"
        dataField="ID_RealStateInstallment" 
        caption="ID Cuota" 
      />
      <!-- <DxColumn dataField="ID_RealStateInstallmentBilling" caption="ID Billing" /> -->
      <DxColumn dataField="ID_Invoice" caption="ID Factura" />

      <DxColumn dataField="IsProcessed" caption="Estado" cell-template="status-cell" />
      <template #status-cell="{ data }">
        <div 
          :style="{
            color: data.data.IsProcessed ? '#A5D6A7' : '#0288D1',
            fontWeight: 'bold',
          }"  
        >
          {{ data.data.IsProcessed ? 'Procesada' : 'Pendiente' }}
        </div>
      </template>

      <DxColumn dataField="InvoiceDate" caption="Fecha de pago" />

      <DxColumn dataField="InvoiceMontoTotalOperacion" caption="Monto" :format="(value) => `$${value}`"/>

      <!-- <DxColumn dataField="InstallmentNumber" caption="Número de cuota" />

      <DxColumn dataField="InstallmentMonth" caption="Mes" />

      <DxColumn dataField="BaseAmount" caption="Cuota base" :format="(value) => `$${value}`"/>

      <DxColumn dataField="InterestAmount" caption="Cuota Interés" :format="(value) => `$${value}`"/>
      
      <DxColumn dataField="BaseBalance" caption="Saldo base" :format="(value) => `$${value}`"/>

      <DxColumn dataField="InterestBalance" caption="Saldo interés" :format="(value) => `$${value}`"/> -->

    </DxDataGrid>

    <Alert
      v-model="alert.show"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      @input="alert.onInputEvent"
      @action="alert.onActionEvent"
    />
  </v-card >
</template>

<script>
import Block from '@/components/Block.vue';
import { DxDataGrid, DxColumn } from "devextreme-vue/data-grid";
import Button from '@/components/Button.vue';
import Alert from '@/components/Alert.vue';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.addVirtualFileSystem(pdfFonts);

export default {
  name: 'LotInstallments',
  components: {
    Block,
    DxDataGrid,
    DxColumn,
    Button,
    Alert,
  },
  props: {
    lotData: {
      type: Object,
      required: true,
    },
    saleData: {
      type: Object,
      required: true,
    },
    installmentData: {
      type: Object,
      required: false,
    },
    installmentsData: {
      type: Array,
      required: false,
    },
    billingData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        onInputEvent: this.closeAlert,
        onActionEvent: this.closeAlert,
      },
      billing: [],
      customers: [],
    };
  },
  methods: {
    async loadCustomers() {
      this.isLoading = true
      try {
        const business = JSON.parse(localStorage.getItem("user")).businessid || ""
        const branch = JSON.parse(localStorage.getItem("user")).branch || ""

        const response = await this.$API.customers.getCustomers({
          business,
          branch
        })

        this.customers = response;
        
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de clientes.', 'error');
      }
      this.isLoading = false;
    },
    loadBilling() {
      this.isLoading = true;
      try {
        if (this.installmentData && typeof this.installmentData === 'object') {
          this.billing = this.billingData.filter(b => {
            return `${b.ID_RealStateInstallment}` === `${this.installmentData.ID_FinancingInstallment}`
          })
        } else {
          this.billing = [...this.billingData]
        }
      } catch(err) {
        console.log(err)
        this.showAlert(
          'Error', 'Ha ocurrido obteniendo la lista de facturas.', 'error', 
          () => this.$emit('close')
        );
      }

      this.isLoading = false;
    },
    getInstallmentTotal(installment) {
      if (!installment) {
        return 0;
      }

      return installment.BaseAmount + installment.InterestAmount;
    },  
    isInstallmentPaid(installment) {
      if (!installment) {
        return false
      }

      const totalBalance = installment.BaseBalance + installment.InterestBalance;

      return totalBalance <= 0;
    },
    round(value, currency = '$') {
      let number = parseFloat(value);

      if (isNaN(number)) {
        return `${currency}0.00`;
      }

      return `${currency}${number.toFixed(2)}`;
    },
    async generateReceiptPdf (rowData) {
      try {
        const docDefinition = {
          pageSize: 'LETTER',
          content: [],
          images: [],
          styles: [],
        };
        const secondaryColor = '#263238'
        const user = JSON.parse(localStorage.getItem("user"));

        const businessId = user.businessid;


        const business = await this.$API.business.FindOne(businessId);

        const logoRow = {
          columns: [],
          marginBottom: 3,
        };
        // logo image
        if (business.BusinessLogoPath && business.BusinessLogoPath.length > 0) {
          try {
            const { 
              imageBase64: logoImageBase64 
            } = await this.$API.utilities.getImageInBase64({ "file": business.BusinessLogoPath });
            if (logoImageBase64) {
              logoRow.columns.push(
                {
                  image: logoImageBase64,
                  fit: [150, 48],
                  alignment: 'left',
                  width: 70,
                },
              );
            }
          } catch (err) {
            console.log(err);
          }
        }
        
        // business name
        logoRow.columns.push({
          text: business.BusinessName,
          fontSize: 16,
          bold: true,
          alignment: 'center',
          marginTop: 12,
          width: '*',
        });

        if (business.BusinessLogoPath && business.BusinessLogoPath.length > 0) {
          logoRow.columns.push({
            text: '',
            width: 70,
          });
        }

        docDefinition.content.push(logoRow);
        
        docDefinition.content.push({
          text: 'COMPROBANTE DE PAGO',
          fontSize: '12',
          bold: true,
          alignment: 'center',
          marginBottom: 10,
        })

        // Lot info
        const lotInfoRow = {
          columns: [
            {
              columns: [
                {
                  text: 'Lotificación:',
                  color: secondaryColor,
                  width: 'auto',
                  marginRight: 4,
                },
                {
                  text: this.lotData.LotName,
                  width: '*',
                }
              ],
            },
            {
              columns: [
                {
                  text: 'Polígono:',
                  color: secondaryColor,
                  width: 'auto',
                  marginRight: 4,
                },
                {
                  text: this.lotData.PolygonNumber,
                  width: '*',
                },
              ],
            },
            {
              columns: [
                {
                  text: 'Lote:',
                  color: secondaryColor,
                  width: 'auto',
                  marginRight: 4,
                },
                {
                  text: this.lotData.LotNumber,
                  width: '*',
                },
              ],
            },
          ],
          fontSize: 11,
          marginBottom: 5,
        }

        docDefinition.content.push(lotInfoRow);

        // customer name
        const customer = this.customers.find(c => c.ID_Customer === this.saleData.ID_Customer);

        const customerName = customer?.LegalName || customer?.BusinessName || '';

        docDefinition.content.push({
          columns: [
            {
              text: 'Nombre:',
              color: secondaryColor,
              width: 'auto',
              marginRight: 4,
            },
            {
              text: (customerName || '').toUpperCase(),
              width: '*',
            },
          ],  
          fontSize: 11,
          marginBottom: 5,
        });

        // period name
        docDefinition.content.push({
          columns: [
            {
              columns: [
                {
                  text: 'Mes a cancelar:',
                  color: secondaryColor,
                  width: 'auto',
                  marginRight: 4,
                },
                {
                  text: (this.installmentData.PeriodName || '').toUpperCase(),
                  width: '*',
                },
              ],
              width: 'auto',
            },
            // Invoice ID
            {
              text: `N° ${rowData.ID_Invoice}`,
              fontSize: 11,
              alignment: 'right',
              color: 'red',
              width: '*',
            }
          ],  
          fontSize: 11,
          marginBottom: 10,
        });

        // Values table

        const {
          InstallmentNumber,
          TotalAmount,
        } = this.installmentData;

        const {
          InvoiceMontoTotalOperacion,
          InvoiceCurrency,
          InvoiceTotalLetras,
          InvoicePaymentType,
          PaymentTypeDescription,
          InvoiceDate,
          AdditionalPayment,
          PreviousBalance,
          NewBalance,
        } = rowData;

        const additionalPayment = this.round(AdditionalPayment);

        const prevBalance = this.round(PreviousBalance);

        const currentBalance = this.round(NewBalance);

        docDefinition.content.push({
          table: {
            headersRow: 1,
            widths: ['auto', '*', '*', '*', '*', '*'],
            body: [
            // Header row
              [
                { text: 'N° Cuota', color: secondaryColor, alignment: 'center' },
                { text: 'Valor cuota', color: secondaryColor, alignment: 'center' },
                { text: 'Pago adicional', color: secondaryColor, alignment: 'center' },
                { text: 'Saldo anterior', color: secondaryColor, alignment: 'center' },
                { text: 'Saldo actual', color: secondaryColor, alignment: 'center' },
                { text: 'Pago total', color: secondaryColor, alignment: 'center', bold: true }
              ],
              [
                {text: InstallmentNumber, alignment: 'center'}, 
                {text: this.round(TotalAmount, InvoiceCurrency), alignment: 'center'}, 
                {text: additionalPayment, alignment: 'center'}, 
                {text: prevBalance, alignment: 'center'}, 
                {text: currentBalance, alignment: 'center'}, 
                {
                  text: this.round(InvoiceMontoTotalOperacion, InvoiceCurrency), 
                  alignment: 'center', 
                  bold: true,
                }
              ]
            ]
          },
          layout: {
            hLineWidth: function() {
              return 0.5;
            },
            vLineWidth: function() {
              return 0.5;  // no vertical lines as in lightHorizontalLines
            },
            hLineColor: function() {
              return '#90A4AE';  // custom horizontal line color
            },
            vLineColor: function() {
              return '#90A4AE';
            },
            paddingLeft: () => 5,
            paddingRight: () => 5,
            paddingTop: () => 5,
            paddingBottom: () => 5,
          },
          fontSize: 10,
          marginBottom: 10,
        })

        // Values in letters
        docDefinition.content.push({
          columns: [
            {
              text: 'Valor en letras:',
              color: secondaryColor,
              width: 'auto',
              marginRight: 4,
            },
            {
              text: (InvoiceTotalLetras|| '').toUpperCase(),
              width: '*',
            },
          ],  
          fontSize: 11,
          marginBottom: 5,
        });

        docDefinition.content.push({
          columns: [
            {
              columns: [
                {
                  text: 'Forma de pago:',
                  color: secondaryColor,
                  width: 'auto',
                  marginRight: 4,
                },
                {
                  text: (InvoicePaymentType || PaymentTypeDescription || '').toUpperCase(),
                  width: '*',
                },
              ],  
            },
            {
              columns: [
                {
                  text: 'Fecha:',
                  color: secondaryColor,
                  width: 'auto',
                  marginRight: 4,
                },
                {
                  text: InvoiceDate,
                  width: '*',
                },
              ],  
            }
          ],
          fontSize: 11,
          marginBottom: 8,
        });

        docDefinition.content.push({
          table: {
            body: [
              [
                {
                  text: 'Los pagos que no se realicen en el mes correspondiente devengarán interés por mora.', 
                  alignment: 'center',  
                  color: secondaryColor,
                  paddingTop: 10,
                }
              ]
            ],
            widths: ['*']
          },
          layout: {
            hLineWidth: function(i) {
              return i === 0 ? 1 : 0;  // only draw top horizontal line
            },
            hLineColor: function() {
              return '#90A4AE';  // custom horizontal line color
            },
            vLineWidth: function() {
              return 0;  // no vertical lines
            },
            paddingTop: function() { return 5; },    // optional padding
            paddingBottom: function() { return 5; }
          },
          fontSize: 11,
          marginTop: 15,
        })

        // Address
        docDefinition.content.push({
          text: business.BusinessAddress + (business.BusinessPhone ? ` Tel.: ${business.BusinessPhone}`: ''),
          fontSize: 11,
          alignment: 'center',
          color: secondaryColor,
          marginBottom: 5,
        });
        pdfMake.createPdf(docDefinition).open();
      } catch (err) {
        console.log(err)
      }

    },
    showAlert(title, message, type = 'success', onInputEvent, onActionEvent) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
      this.alert.onInputEvent = onInputEvent 
        ? onInputEvent
        : this.closeAlert;
      this.alert.onActionEvent = onActionEvent 
        ? onActionEvent
        : this.closeAlert;
      
    },
    closeAlert() {
      this.alert.show = false;
    },
  },
  mounted() {
    this.loadBilling();
    this.loadCustomers();
  }
}
</script>
